import { useTranslation } from "react-i18next";
import { formatDateTime } from "../../../shared/formatting/dateTimes";
import { formatTimeAgo } from "../../../shared/formatting/relativeTimes";
import ForkIcon from "../../../ui/icons/ForkIcon";
import { classNames } from "../../../ui/styles/classNames";

interface ThreadRowMetaProps {
  /** The host's name; `null` when the viewer hosts the Thread, which needs no saying. */
  hostName: string | null;
  lastActivityAt: string;
  fork: boolean;
  className?: string;
}

/**
 * A listed Thread's host and last activity, as "Ada, 6 hr. ago", with a fork marked by its
 * icon. A long host name is cut short; the time always shows in full.
 */
export default function ThreadRowMeta({ hostName, lastActivityAt, fork, className }: ThreadRowMetaProps) {
  const { t, i18n } = useTranslation();
  return (
    <span className={classNames("app-text-muted flex min-w-0 items-center gap-1.5 text-xs", className)}>
      {fork ? (
        <span className="shrink-0" title={t("threads.list.fork")}>
          <ForkIcon className="h-3 w-3" />
          <span className="sr-only">{t("threads.list.fork")}</span>
        </span>
      ) : null}
      <span className="flex min-w-0 whitespace-nowrap">
        {hostName === null ? null : (
          <>
            <span className="min-w-0 truncate" title={hostName}>{hostName}</span>,&nbsp;
          </>
        )}
        <time className="shrink-0" dateTime={lastActivityAt} title={formatDateTime(lastActivityAt, i18n.resolvedLanguage)}>
          {formatTimeAgo(lastActivityAt, i18n.resolvedLanguage)}
        </time>
      </span>
    </span>
  );
}
